<template>
	<div>
		<el-button v-if="isView" type="primary" @click="handleEdit" v-auth="['configure:rules:talentClue:concactObtain:edit']">编辑规则</el-button>
		<div class="rule-show mt-16" v-if="isView">
			<InfoCard title="新达人线索自动获取公开联系方式">
				<template slot="content">
					<div class="rule-type yx-color-text-primary font-h4-regular">{{ autoGetConcact ? '已开启' : '未开启' }}</div>
					<div class="rule-type yx-color-text-primary font-h4-regular" v-if="autoGetConcact">平台：{{ pfName }}</div>
				</template>
			</InfoCard>
			<div class="content"></div>
		</div>
		<template v-if="isEdit && $auth.hasPermi('configure:rules:talentClue:concactObtain:edit')">
			<div class="flex-row flex-just-start">
				<div class="font-h4-regular">
					<span class="yx-color-text-primary">新达人线索自动获取公开联系方式</span>
					<span class="color-gy-7 font-h6-regular cursor-pointer" @click="openRules">《规则说明》</span>
				</div>
				<div class="ml-16 mt-2">
					<el-switch :active-value="1" :inactive-value="0" v-model="autoGetConcact"></el-switch>
					<div class="yx-background radius-8 pl-24 pr-24 pt-12 pb-12 mt-10" v-if="autoGetConcact">
						<el-checkbox-group v-model="checkedPF">
							<el-checkbox v-for="item in pfList" :label="item.value" :key="item.value">{{ item.label }}</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
			</div>
			<div class="operate-bottom">
				<el-button @click="cancel">取消</el-button>
				<el-button type="primary" @click="submit">保存</el-button>
			</div>
		</template>
		<CancelDialog @back="back" ref="cancelDialog" />
		<rulesText ref="rulesText" />
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import dataMap, { PLATFORM_DY, PLATFORM_KS } from '@/utils/dataMap';
import { autoGetContactSet, autoGetContactInfo } from '@/api/settings';
import CancelDialog from '@/views/settings/components/cancelDialog.vue';
import InfoCard from './infoCard.vue';
import rulesText from './rulesText.vue';
export default {
	components: {
		InfoCard,
		CancelDialog,
		rulesText,
	},
	computed: {
		...mapGetters(['platformVersion']),
		pfList() {
			let arr = [
				{ ...PLATFORM_DY, isShow: this.platformVersion.includes(+PLATFORM_DY.value) },
				{ ...PLATFORM_KS, isShow: this.platformVersion.includes(+PLATFORM_KS.value) },
				// { ...PLATFORM_SP, isShow: this.platformVersion.includes(+PLATFORM_SP.value) },
				// { ...PLATFORM_XHS, isShow: this.platformVersion.includes(+PLATFORM_XHS.value) },
			].filter(v => v.isShow);
			return arr;
		},
		isEdit() {
			return this.mode === 'edit';
		},
		isView() {
			return this.mode === 'view';
		},
	},
	data() {
		return {
			autoGetConcact: 0,
			checkedPF: [],
			mode: 'view',
			pfName: '',
		};
	},
	created() {
		this.getContactInfo();
	},
	methods: {
		async getContactInfo() {
			const { platformList = [], status = 0 } = await autoGetContactInfo();
			this.checkedPF = platformList;
			const temPF = {
				[dataMap.PLATFORM_DY.value]: dataMap.PLATFORM_DY.label,
				// [dataMap.PLATFORM_XHS.value]: dataMap.PLATFORM_XHS.label,
				// [dataMap.PLATFORM_SP.value]: dataMap.PLATFORM_SP.label,
				[dataMap.PLATFORM_KS.value]: dataMap.PLATFORM_KS.label,
			};
			this.pfName =
				platformList
					.map(item => {
						return temPF[item];
					})
					.join('、') || '暂无平台';
			this.autoGetConcact = status;
		},
		async submit() {
			const { autoGetConcact, checkedPF } = this;
			if (autoGetConcact && !checkedPF.length) return this.$message.error('请至少选择一个平台！');
			await autoGetContactSet({ status: autoGetConcact, platformList: autoGetConcact ? checkedPF : [] });
			this.$message.success('操作成功！');
			this.getContactInfo();
			this.mode = 'view';
		},
		cancel() {
			this.$refs.cancelDialog.show();
		},
		back() {
			this.getContactInfo();
			this.mode = 'view';
		},
		handleEdit() {
			this.mode = 'edit';
		},
		openRules() {
			this.$refs.rulesText.show();
		},
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-checkbox {
	margin-right: 24px;
}
/deep/ .el-checkbox__label {
	padding-left: 8px;
}
.operate-bottom {
	position: fixed;
	bottom: 0;
	left: 148px;
	height: 64px;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.08), 0px -2px 6px 0px rgba(0, 0, 0, 0.06), 0px -4px 8px 2px rgba(0, 0, 0, 0.04);
}
</style>
